var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTab3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 41.1667V0H39V41.1667L32.5 36.8333L26 41.1667L19.5 36.8333L13 41.1667L6.5 36.8333L0 41.1667ZM30.3333 13V8.66667H26V13H30.3333ZM21.6667 13V8.66667H8.66667V13H21.6667ZM21.6667 17.3333H8.66667V21.6667H21.6667V17.3333ZM26 21.6667H30.3333V17.3333H26V21.6667Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 41.1667V0H39V41.1667L32.5 36.8333L26 41.1667L19.5 36.8333L13 41.1667L6.5 36.8333L0 41.1667ZM30.3333 13V8.66667H26V13H30.3333ZM21.6667 13V8.66667H8.66667V13H21.6667ZM21.6667 17.3333H8.66667V21.6667H21.6667V17.3333ZM26 21.6667H30.3333V17.3333H26V21.6667Z",
    fill: "url(#paint0_linear_444_5337)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_444_5337",
    x1: 36.47,
    y1: -2.50907,
    x2: -8.32686,
    y2: 29.2295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3AACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab3);
export default __webpack_public_path__ + "static/media/tab-3.1b8dacb5c62729ef319e8f127be099d3.svg";
export { ForwardRef as ReactComponent };